// extracted by mini-css-extract-plugin
export var background = "styles-module--background--deWea";
export var wrapper = "styles-module--wrapper--gc4WK";
export var titleStyle = "styles-module--title-style--QwXVm";
export var descriptionStyle = "styles-module--description-style--CGKth";
export var numberStyle = "styles-module--number-style--3Y97H";
export var pageStyle = "styles-module--page-style--XPJ9l";
export var buttonStyle = "styles-module--button-style--7hDdD";
export var pbCorrectionBut = "styles-module--pb-correction-but--ey3-C";